var EnumUtilities = /** @class */ (function () {
    function EnumUtilities() {
    }
    EnumUtilities.getNames = function (enumType) {
        return Object.keys(enumType).filter(function (v) { return isNaN(parseInt(v, 10)); });
    };
    EnumUtilities.getValues = function (enumType) {
        return Object.keys(enumType).map(function (v) { return parseInt(v, 10); }).filter(function (v) { return !isNaN(v); });
    };
    EnumUtilities.getNamesAndValues = function (e) {
        return EnumUtilities.getValues(e).map(function (v) {
            return { name: e[v], value: v };
        });
    };
    EnumUtilities.getNumber = function (e) {
        var result = e;
        return result;
    };
    EnumUtilities.getName = function (e, v) {
        if (!e || !v)
            return "";
        return e[v];
    };
    EnumUtilities.getValueFromName = function (e, name) {
        return e[name];
    };
    return EnumUtilities;
}());
export { EnumUtilities };
var EnumItem = /** @class */ (function () {
    function EnumItem() {
    }
    return EnumItem;
}());
export { EnumItem };
